import { getStoredParams } from './tracking-params';
import type { ChatButtonVariant } from './ai-chat';

/** Server-side Sheets log for the chat button A/B test (separate from dataLayer). */
const FN_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/chat-ab-log`;
const ANON = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
const SESSION_KEY = 'taoh-ai-chat-ab-session';
const VIEWED_KEY = 'taoh-ai-chat-ab-viewed';

export type ChatAbEvent = 'button_view' | 'button_click' | 'chat_open';

export function shouldLogChatAb(host = window.location.hostname, nav: Navigator = navigator) {
  if (nav.webdriver || /headless|bot|crawler|spider|lighthouse/i.test(nav.userAgent)) return false;
  return !/lovable\.app$|lovableproject\.com$|lovable\.dev$|^localhost$|^127\.0\.0\.1$/i.test(host);
}

const sessionId = () => {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) { id = crypto.randomUUID(); sessionStorage.setItem(SESSION_KEY, id); }
    return id;
  } catch { return crypto.randomUUID(); }
};

const device = () => {
  const w = window.innerWidth;
  return w < 768 ? 'mobile' : w < 1024 ? 'tablet' : 'desktop';
};

/** Returns true only the first time a path is viewed in this session. */
export function claimChatAbView(path: string) {
  try {
    const seen: string[] = JSON.parse(sessionStorage.getItem(VIEWED_KEY) || '[]');
    if (seen.includes(path)) return false;
    sessionStorage.setItem(VIEWED_KEY, JSON.stringify([...seen, path]));
    return true;
  } catch { return true; }
}

export function logChatAb(event: ChatAbEvent, variant: ChatButtonVariant) {
  if (!shouldLogChatAb()) return;
  const params = getStoredParams();
  const url = new URLSearchParams(window.location.search);
  const body = JSON.stringify({
    event, variant, session_id: sessionId(), page_path: window.location.pathname, device: device(),
    referrer: document.referrer, utm_source: url.get('utm_source') ?? params.utm_source ?? '',
    utm_campaign: url.get('utm_campaign') ?? params.utm_campaign ?? '',
    landing_page_variation: url.get('landing_page_variation') ?? params.landing_page_variation ?? '',
  });
  fetch(FN_URL, { method: 'POST', keepalive: true, body, headers: { 'Content-Type': 'application/json', apikey: ANON, Authorization: `Bearer ${ANON}` } }).catch(() => undefined);
}
